import React from "react";
import { Table } from "reactstrap";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const PrintableTable = ({ supplierItems }) => {
  return (
    <Table hover bordered className="print-table">
      <thead className="table-light">
        <tr>
          <th style={{ width: "60px" }}>S.N</th>
          <th style={{ width: "150px" }}>Purchase Item ID</th>
          <th style={{ width: "130px" }}>Purchase ID</th>
          <th style={{ width: "150px" }}>Purchase Name</th>
          <th style={{ width: "100px" }}>Quantity</th>
          <th style={{ width: "150px" }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {supplierItems.map((row, index) => (
          <tr key={row.purchaseItemId}>
            <td>{index + 1}</td>
            <td>{row.purchaseItemId}</td>
            <td>{row.purchaseId}</td>
            <td>{row.purchaseName}</td>
            <td className="text-end">{row.quantity}</td>
            <td className="text-end">
              <NumberCommas number={row.amount} />
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot className="table-group-divider">
        <tr>
          <td colSpan="4" className="text-end fw-bold">
            Total
          </td>
          <td className="text-end fw-bold">
            {supplierItems.reduce((sum, row) => sum + row.quantity, 0)}
          </td>
          <td className="text-end fw-bold">
            <NumberCommas
              number={supplierItems.reduce((sum, row) => sum + row.amount, 0)}
            />
          </td>
        </tr>
      </tfoot>
    </Table>
  );
};

export default PrintableTable;